import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../assets/images/logo.png";
import { toastAlert } from "../helper/toastAlert";

import { useWallet } from "../pages/walletconnect/walletContext";
import { useNavigate } from "react-router-dom";
// import { useDisconnect } from "wagmi";

export default function MyNavbarInner(props) {
  const { address, isConnected, connectors, connectWallet, disconnectWallet } = useWallet();
  // const { disconnectAsync } = useDisconnect()
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate()

  async function logout() {
    setLoader(true)
    console.log('disconnectWallet :', disconnectWallet);
    await disconnectWallet()
    console.log("disconnectWallet :")
    await new Promise((resolve) => setTimeout(resolve, 2000));
    localStorage.clear()
    sessionStorage.clear();
    await new Promise((resolve) => setTimeout(resolve, 1500));
    localStorage.setItem("disableAutoConnect", "true");
    navigate("/")
    toastAlert("success", "Successfully Logout", "logout");
    setLoader(false)
  }
  return (
    <>

      <nav class="navbar navbar-expand-md  nav_bar">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img src={logo} alt="logo" className="img-fluid" />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="offcanvas offcanvas-end nav_offcanva"
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div class="offcanvas-header">
              <a class="navbar-brand" href="/">
                <img src={logo} alt="logo" className="img-fluid" />
              </a>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <div class="navbar-nav justify-content-end flex-grow-1 pe-3">
                <Nav.Link href="/dashboard" className="primary_btn me-3">
                  Dashboard
                </Nav.Link>
                <Nav.Link href="/token" className="primary_btn me-3">
                  WIN Token
                </Nav.Link>
                <Nav.Link className="nav_btn" onClick={() => logout()}>
                  {loader ? <i className="fas fa-spinner fa-spin"></i> : "LogOut"}
                </Nav.Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
